import type { Supplier } from '@/types'

interface SupplierRowProps {
  supplier: Supplier
  onClick: () => void
}

export function SupplierRow({ supplier, onClick }: SupplierRowProps) {
  const altNamesCount = supplier.alternative_names?.length || 0

  return (
    <tr
      className="hover:bg-gray-50 cursor-pointer"
      onClick={onClick}
      data-testid={`supplier-row-${supplier.id}`}
    >
      <td className="px-4 py-3 text-sm font-medium text-gray-900">
        {supplier.name}
      </td>
      <td className="px-4 py-3 text-sm text-gray-500">
        {altNamesCount > 0 ? (
          <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800">
            {altNamesCount} alternative{altNamesCount !== 1 ? 's' : ''}
          </span>
        ) : (
          <span className="text-gray-400">—</span>
        )}
      </td>
      <td className="px-4 py-3 text-sm text-gray-500 text-right">
        <svg
          className="w-5 h-5 text-gray-400 inline"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 5l7 7-7 7"
          />
        </svg>
      </td>
    </tr>
  )
}
